import React, {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import UserService from "../../../services/UserService";
import Spinner from "reactjs-simple-spinner";
import NavBar from "../../../common/NavBar";
import SideBar from "../../../common/SideBar";
import avatar from '../../../assets/images/avatar.png'
import {makeStyles} from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import TextField from "@material-ui/core/TextField";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import {toast, ToastContainer} from "react-toastify";
import validator from 'validator';


const useStyles = makeStyles((theme) => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    root: {
        flexGrow: 1,
        // backgroundColor: theme.palette.background.paper,
    },
    root1: {
        width: '100%',
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        flexBasis: '33.33%',
        flexShrink: 0,
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
    },
    paper: {
        position: 'absolute',
        width: "45%",
        backgroundColor: theme.palette.background.paper,
        border: '0.2px solid #000',
        boxShadow: theme.shadows[1],
        padding: theme.spacing(2, 4, 3),
    },
}));

const Profile = (props) => {

    const [user, setUser] = useState(JSON.parse(localStorage.getItem('user')));
    const [roles, setRoles] = useState({})
    const [loading, setLoading] = useState(true);
    const [updateLoading, setUpdateLoading] = useState(false);
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);
    const [password, setPassword] = useState(undefined);
    const [current_password, setCurrentPassword] = useState('');
    const [errorMessage, setErrorMessage] = useState('')


    const validate = (value) => {

        if (validator.isStrongPassword(value, {
            minLength: 8, minLowercase: 1,
            minUppercase: 1, minNumbers: 1, minSymbols: 1
        })) {
            setErrorMessage('Is Strong Password')
            setPassword({...password, newPassword: value})

        } else {
            setErrorMessage('Is Not Strong Password')
        }
    }


    const handleClose = () => {
        setOpen(false);
    };
    const handleOpen = () => {
        setOpen(true);
    };

    const stopLoading = () => {
        setLoading(false)
    }


    const handleUpdate = (e) => {
        e.preventDefault();
        setUpdateLoading(true);
        const u = UserService.getCurrentUser();

        //call service


        let data = {
            'email': u.email,
            'current_password': current_password,
            'new_password': password.newPassword
        }

        console.log(data);

        UserService.changePassword(data)
            .then(res => {
                console.log("response: ", res.response)
                if (res.status === 200) {
                    console.log(res);
                    toast.success('Password Changed Successfully', {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    handleClose()
                    setUpdateLoading(false);

                } else if (res.status === 400) {

                    toast.warning('Operation Failed: ' + res.response.data.message, {
                        position: "top-center",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    setUpdateLoading(false);
                } else {
                    toast.warning('Operation Failed: ' + res.response.data.message, {
                        position: "top-center",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    setUpdateLoading(false);
                }

            }).catch(err => {
            console.log("error: ", err.response);
            setUpdateLoading(false);
            toast.warning('Operation Failed: ' + err.response.data.message, {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });

        })


    }

    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
        setErrorMessage('')
        setLoading(true);
        setUpdateLoading(false);
        handleClose()
        const u = UserService.getCurrentUser();
        console.log(u);
        UserService.getUser(u.id)
            .then(res => {
                console.log("user: ", res.data.data)
                setRoles(res.data.data.roles);
                setUser(res.data.data);

                setLoading(false);
            })
            .catch(err => {
                setLoading(false);
                console.log(err)
            })


    }, []);

    // const handleChange = name => ({target: {value}}) => {
    //     setPassword({...password, [name]: value})
    // }

    return (
        <>
            <ToastContainer
                position="top-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <SideBar roles={JSON.parse(localStorage.getItem('roles'))}/>
            <div
                id="main-content" className="main-panel ps-container ps-theme-default">
                <NavBar roles={JSON.parse(localStorage.getItem('roles'))}/>

                {/*UPDATE MODAL*/}
                <Modal
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    className={classes.modal}
                    open={open}
                    onClose={handleClose}
                    closeAfterTransition
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                        timeout: 500,
                    }}
                >
                    <Fade in={open}>
                        <div className={classes.paper}>
                            <div>
                                <Dialog
                                    open={open}
                                    onClose={handleClose}
                                    aria-labelledby="form-dialog-title"
                                >
                                    <DialogTitle id="form-dialog-title">Change Password</DialogTitle>
                                    {updateLoading && (
                                        <div className="mr-5 ml-5 mt-5 mb-5 p-5">
                                            <Spinner
                                                size="large"
                                                message="Changing Password,Please wait....."
                                                line-fg-color="#64c3c2"
                                            />
                                        </div>
                                    )}
                                    {!updateLoading && (
                                        <>
                                            <DialogContent>
                                                <DialogContentText></DialogContentText>
                                                <TextField
                                                    autoFocus
                                                    margin="dense"
                                                    label="Token Verified"
                                                    type="text"
                                                    disabled={true}
                                                    fullWidth
                                                />
                                                <TextField
                                                    className="mb-3"
                                                    margin="dense"
                                                    label="Current Password"
                                                    type="password"
                                                    fullWidth
                                                    onChange={(e) => setCurrentPassword(e.target.value)}
                                                />
                                                <TextField
                                                    className="mb-3"
                                                    margin="dense"
                                                    label="New Password"
                                                    type="password"
                                                    fullWidth
                                                    onChange={(e) => validate(e.target.value)}
                                                />
                                                {errorMessage === 'Is Strong Password' ? (
                                                    <span className="mt-2" style={{
                                                        fontWeight: 'bold',
                                                        color: 'green',
                                                    }}>
                                                    {errorMessage}
                                                </span>
                                                ) : (
                                                    <span className="mt-2" style={{
                                                        fontWeight: 'bold',
                                                        color: 'red',
                                                    }}>
                                                    {errorMessage}
                                                </span>
                                                )}
                                                <p>
                                                    <span
                                                        className="text-muted text-danger mt-2">Password Requirements:</span>
                                                    &nbsp;Should be 8 characters long,
                                                    &nbsp;At least 1 Uppercase Character [Aa-Zz],
                                                    &nbsp;At least 1 symbolic character (@,#,$, e.t.c...),
                                                    &nbsp;At least 1 digit [0-9]
                                                </p>
                                                {/*<TextField*/}
                                                {/*    margin="dense"*/}
                                                {/*    label="Confirm Password"*/}
                                                {/*    type="text"*/}
                                                {/*    fullWidth*/}
                                                {/*    onChange={handleChange('matchingPassword')}*/}
                                                {/*/>*/}

                                            </DialogContent>
                                            <DialogActions>
                                                <Button onClick={handleClose} color="primary">
                                                    Cancel
                                                </Button>
                                                <Button onClick={handleUpdate}
                                                        className="btn btn-round btn-sm btn-primary">
                                                    Update Password
                                                </Button>
                                            </DialogActions>
                                        </>
                                    )}

                                </Dialog>
                            </div>
                        </div>
                    </Fade>
                </Modal>
                <div className="content">
                    <div className="container-fluid">
                        <div className="container">
                            {loading && (
                                <div className="mr-5 ml-5 mt-5 mb-5 p-5">
                                    <Spinner
                                        size="large"
                                        message="Please wait....."
                                        line-fg-color="#64c3c2"
                                    />
                                </div>
                            )}

                            {!loading && (
                                <div className="main-body">

                                    <nav aria-label="breadcrumb" className="main-breadcrumb">
                                        <ol className="breadcrumb">
                                            <Link to="/dashboard"><a href><i className="fa fa-home"/>&nbsp;Dashboard</a>
                                            </Link>
                                             &nbsp;|&nbsp;
                                            <Link to="/settings"><a href><i
                                                className="fa fa-cog"/>&nbsp;Settings</a></Link>
                                             &nbsp;|&nbsp;
                                            <li className="breadcrumb-item active" aria-current="page">User Profile</li>
                                        </ol>
                                    </nav>


                                    <div className="row gutters-sm">
                                        <div className="container col-md-6">
                                            <div className="card">
                                                <div className="card-body">
                                                    <div className="d-flex flex-column align-items-center text-center">
                                                        <img
                                                            src={avatar}
                                                            alt="Admin"
                                                            className="rounded-circle" width="150"/>
                                                        <div className="mt-3">
                                                            <h4>{user.firstName}&nbsp;{user.lastName}</h4>
                                                            <p className="text-secondary mb-1"> {user.email}</p>
                                                            <p className="text-secondary mb-1"> Roles:
                                                                {roles.map((role, i) => (
                                                                    <span
                                                                        className="badge bg-success text-capitalize p-1 m-1">{role.name}</span>
                                                                ))}

                                                            </p>
                                                            <p className="text-muted text-primary font-size-sm">Nhaka
                                                                Life Insurance</p>

                                                        </div>
                                                        <button
                                                            onClick={handleOpen}
                                                            className="btn btn-sm btn-outline-primary">
                                                            Change Password
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )

}

export default Profile;
